import PropTypes from "prop-types";

import CustomPagination from "../../../components/custom-component/CustomPagination";
import { MobileFilterBar } from "../../../components/data-table";
import CustomerListCards from "./CustomerListCards";

function CustomerListPanel({
    t,
    customers,
    loading,
    totalItemCount,
    pageSize,
    setPageSize,
    currentPage,
    setCurrentPage,
    filters,
    customerActionItems,
    onActionClick,
}) {
    return (
        <>
            <h1 className="text-lg font-bold text-[#2F2F46]">
                {t("pageTitle")}
                <span className="text-[#2F2F46]">({totalItemCount})</span>
            </h1>

            <MobileFilterBar
                filters={filters}
                search={{ key: "searchTerm", placeholder: t("listSearchPlaceholder") }}
                filterLabels={{
                    email: t("email"),
                    mobileNumber: t("phone"),
                    "drivingLicense.number": t("licenseNumber"),
                }}
            />

            <CustomerListCards
                customers={customers}
                loading={loading}
                actionItems={customerActionItems}
                onActionClick={onActionClick}
                t={t}
            />

            <div className="flex min-w-0 w-full justify-end">
                <CustomPagination
                    variant="spaced"
                    totalItem={totalItemCount}
                    pageSize={pageSize}
                    setPageSize={setPageSize}
                    currentPage={currentPage}
                    setCurrentPage={setCurrentPage}
                    pageSizeOptions={[10, 20, 50, 100]}
                    showSizeChanger
                />
            </div>
        </>
    );
}

CustomerListPanel.propTypes = {
    t: PropTypes.func.isRequired,
    customers: PropTypes.array.isRequired,
    loading: PropTypes.bool.isRequired,
    totalItemCount: PropTypes.number.isRequired,
    pageSize: PropTypes.number.isRequired,
    setPageSize: PropTypes.func.isRequired,
    currentPage: PropTypes.number.isRequired,
    setCurrentPage: PropTypes.func.isRequired,
    filters: PropTypes.object.isRequired,
    customerActionItems: PropTypes.array.isRequired,
    onActionClick: PropTypes.func.isRequired,
};

export default CustomerListPanel;
